import Alpine from 'alpinejs';

import Accordion from './components/accordion';
import Advisors from './components/advisors';
import AsyncForm from './components/async-form';
import Consulting from './components/consulting';
import Modal from './components/modal';
import News from './components/news';
import Rating from './components/rating';
import SelfAssessment from './components/self-assessment';

window.Alpine = Alpine;

Alpine.data('advisors', Advisors);
Alpine.data('asyncForm', AsyncForm);
Alpine.data('consulting', Consulting);
Alpine.data('rating', Rating);
Alpine.data('selfAssessment', SelfAssessment);
Alpine.data('accordion', Accordion);
Alpine.data('modal', Modal);
Alpine.data('news', News);

Alpine.start();
